import { useRef, useState } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { FlightInfoOrders } from 'pages/avia/my-ticket/pages/ListPassengers/components/flight-info-orders'

import { prepareFlightDataForInfoOrders } from 'entities/tour/libs/flightData'
import { getRouteInfo } from 'entities/tour/libs/routeInfo'

import { Flight } from 'shared/api/tours/flights/model'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { getContentStyles } from 'shared/ui/collapse/lib/getContentHeight'
import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

interface FlightDetailsBlockProps {
  flight: Flight | null
}

export const FlightDetailsBlock = ({ flight }: FlightDetailsBlockProps) => {
  const { t } = useTranslation()
  const contentRef = useRef<HTMLDivElement>(null)
  const [isOpen, setIsOpen] = useState(false)

  if (!flight?.transport?.length) {
    return null
  }

  const routeInfo = getRouteInfo(flight.transport)
  const routeDisplay = routeInfo ? routeInfo.replace(/\s*—\s*/g, ' → ') : ''
  const ticketsDirections = prepareFlightDataForInfoOrders(flight.transport)
  const contentStyles = getContentStyles(false, isOpen, contentRef)

  const toggleOpen = () => {
    setIsOpen((prev) => !prev)
  }

  return (
    <Paper
      padding={[16]}
      radius={16}
      className={s.wrapper}
    >
      <div
        role="button"
        className={s.header}
        onClick={toggleOpen}
      >
        <div className={s.headerText}>
          <span className={clsx(s.title, 'semi-bold-16')}>
            {t('detail_flight')}
          </span>
          {!isOpen && routeDisplay && (
            <span className={clsx(s.description, 'regular-14')}>
              {routeDisplay}
            </span>
          )}
        </div>
        <AppIcon
          id={AllIcons.ARROW_BOTTOM}
          className={clsx(s.icon, isOpen && s.iconOpen)}
          width={24}
          height={24}
        />
      </div>

      <div
        ref={contentRef}
        style={contentStyles}
        className={clsx(s.content, isOpen && s.contentOpen)}
      >
        <FlightInfoOrders
          title={routeInfo}
          ticketsDirections={ticketsDirections}
          padding={[0]}
        />
      </div>
    </Paper>
  )
}
